import React from 'react';
import { Box, Typography, Button } from "@mui/material";

const DQProgramConfirmation = () => {
    return (
        <Box sx={{ p: 3, maxWidth: 1200, textAlign: 'left' }}>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
                Thanks for reviewing your custom program summary!
            </Typography>

            <Typography paragraph>
                We'll now use this information to generate your tailored:
            </Typography>

            <Box sx={{ mb: 3, textAlign: 'left', maxWidth: 600, mr: 'auto' }}>
                <ul>
                    <li><Typography>Program Outline (Modules, Units, Sessions)</Typography></li>
                    <li><Typography>Session Flow & Format</Typography></li>
                    <li><Typography>Pre and Post Assessments (that can be optionally used to test your learners)</Typography></li>
                </ul>

            </Box>

            <Typography paragraph sx={{ mb: 3 }}>
                Your AI literacy program is built on proven educational psychology and curriculum design principles to ensure students
                not only understand technology, but also think critically and act responsibly in an AI-driven world. Drawing from the work
                of Piaget (learning through active experience), Vygotsky (social learning and scaffolding), Bruner (spiral curriculum),
                Erikson (emotional and identity development), and Bloom (progressive cognitive challenge), the framework is
                developmentally aligned to support students at every stage. It emphasizes relevance to students' daily lives, integration
                across subjects, hands-on learning, and clear, age-appropriate goals—so educators can confidently guide learners from basic understanding to ethical reasoning and creative application of AI.
            </Typography>

            <Typography paragraph sx={{ mb: 4 }}>
                <a href="#" style={{ color: '#018FA6', textDecoration: 'none' }}>
                    Learn more about our Foundational Framework for AI Literacy Curriculum Design.
                </a>
            </Typography>

            <Typography variant="h6" sx={{ mb: 4 }}>
                You're all set to proceed to the Program Outline and Syllabus Generation stage.
            </Typography>

            <Button
                variant="contained"
                sx={{
                    backgroundColor: '#FE686F',
                    color: 'white',
                    borderRadius: '15px',
                    px: 4,
                    py: 1.5,
                    '&:hover': {
                        backgroundColor: '#FE686F',
                        opacity: 0.9
                    }
                }}
            >
                Next
            </Button>
        </Box>
    );
};

export default DQProgramConfirmation;